// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'

// Perform a check on componentDidMount to verify that the user's logged in.
// if they're not logged in, then return null and tell redux to send them to the login page.
const AuthRoute = props => {
  const authenticatedUser = useSelector(state => !!state.user.get('userId'))
  const referrer = props?.location.pathname

  return (
    authenticatedUser
      ? (
        <Route {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            referrer,
          }} />
      )
  )
}

AuthRoute.propTypes = {
  location: object,
}

export default AuthRoute
